import { axiosGet } from "../../react_axios/Axios";
import { GET_EVENT_GUIDE_DETAILS, getEventGuideDetailsUrl, headers } from "../../utils/constants";

export const getEventGuideDetails_action = (name) => async (dispatch) => {

    try {
        const params = {
            Name: name
        }

        const res = await axiosGet(getEventGuideDetailsUrl, params, headers)

        dispatch({
            type: GET_EVENT_GUIDE_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}